<router-outlet></router-outlet>
<app-consent-banner testId="consent-banner"></app-consent-banner>
